export { default } from './ProvinceTransactionRestriction';
